import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card, Dropdown } from 'react-bootstrap';
import AuthCornerImage from '../../../../assets/img/illustrations/authentication-corner.png';
import { breakpoints, capitalize } from '../../helpers/utils';
import { topNavbarBreakpoint } from '../../config';
import { childrenPropType } from '../../../../constants/backend/propTypes';

function NavbarDropdown({ title, children }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <Dropdown
      show={dropdownOpen}
      onToggle={() => setDropdownOpen(!dropdownOpen)}
      onMouseOver={() => {
        const windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(true);
        }
      }}
      onMouseLeave={() => {
        const windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(false);
        }
      }}
    >
      <Dropdown.Toggle as={Link} to="#!" className="nav-link fw-semi-bold">
        {capitalize(title)}
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-card mt-0 dropdown-caret">
        {/* {children} */}
        <Card
          className="shadow-none dark__bg-1000 navbar-card-app"
        >
          <Card.Body
            className="scrollbar max-h-dropdown _p-0 _py-2"
          >
            {title !== 'dashboard' && title !== 'documentation' && (
              <img
                src={AuthCornerImage}
                alt=""
                className="img-dropdown"
                width={130}
              />
            )}
            {children}
          </Card.Body>
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
}

NavbarDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  children: childrenPropType.isRequired,
};

export default NavbarDropdown;
